import './styles/index.sass'
import './styles/slick.scss'
import React from 'react'
import MainRouter from './components/main-router'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { createRoot } from 'react-dom/client';
const version = require('../package.json').version

const versionPbx = process.env.IS_BROWSER + '' === 'true' && window.localStorage.pbxVersion
if (process.env.IS_BROWSER + '' === 'true' && version && version != versionPbx) {
  window.localStorage.pbxVersion = version
  // @ts-ignore
  window.location.reload(true)
}

const queryClient = new QueryClient()

declare global {
  interface Window {
    SERVER_DATA?: any,
    yaCounter631388?: any,
    amplitude?: any
  }
}


const container = document.getElementById('wrapper')
const root = createRoot(container)
root.render(
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <MainRouter />
    </BrowserRouter>
  </QueryClientProvider>
)
